/* eslint-disable */
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const TermsPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default TermsPropTypes;
